import React from "react";
import "./Main.css";
import worldMap from "../../assets/Oceans.jpg";
import Navbar2 from "../Navbar/Navbar2/Navbar2";
import { FaLightbulb, FaCogs, FaTools, FaRobot, FaShip, FaChartLine, FaNetworkWired, FaCog, FaEye, FaServer, FaUserTie, FaUsers, FaCrown, FaShieldAlt, FaCertificate, FaWrench, FaGraduationCap, FaCompass, FaTachometerAlt, FaLeaf, FaComments } from "react-icons/fa";
import { FaGear } from "react-icons/fa6";
import Footer from "../Footer/Footer";
import he_img from "../../assets/he_image.png";


const Main = ({ onNavigate }) => {
  return (
    <div className="main-page">
     <Navbar2 onNavigate={onNavigate} />
      {/* Hero Section */}
       <section className="hero-section">
    <div className="hero-content">
      <h1>Make Global Trade Smarter,<br />Cleaner, and Stronger</h1>
      <p className="subheading">Powering Maritime Performance That Actually Matters</p>
      <p className="desc">
        Every tonne of fuel saved, every emission avoided, every hour optimised—it all matters.<br />
        Because behind every ship is a business. Behind every decision, a person.
      </p>
      <p className="desc highlight">
        At AI Shipshape, we help shipping companies see more clearly, act more confidently, and
        lead more responsibly.
      </p>
      <div className="hero-buttons">
        <button className="btn filled" onClick={() => onNavigate('contact')}>Demo</button>
        <button
          className="btn outline"
          onClick={() =>
            document
              .getElementById('optimize-section')
              .scrollIntoView({ behavior: 'smooth' })
          }
        >
          Learn More
        </button>
      </div>
    </div>
    <div className="hero-image">
      <img src={he_img} alt="Illustration of smart shipping" />
    </div>
  </section>

      {/* Section 2: World Map and Text */}
      <section id="optimize-section" className="optimize-section">
        <div className="optimize-container">
            <div className="optimize-image">
            <img src={worldMap} alt="AI World Map" />
            </div>
            <div className="optimize-text">
            <h2>
                Optimise What You Can Control.<br />
                Predict What You Can't.
            </h2>
            <p>
                Our AI-powered platform gives you the tools to optimise routes, monitor engines,
                reduce emissions, and guide your team—whether at sea or ashore.
            </p>
            <p>
                All in real time. All without changing your existing systems.
            </p>
            <p className="emphasis">
                Whether you're chasing better margins, hitting CII targets, or simply trying to run a tighter ship,
                we make sure you're always ahead of the curve.
            </p>
            </div>
        </div>
        </section>


      {/* Section 3: Cards */}
      <section className="main-features-section">
      <h2 className="section-title">Shipshape Means</h2>
      <div className="main-feature-cards">
        {[
          {
            icon: (
              <FaLightbulb
                style={{
                  color: "#0e2430", // Gold
                  textShadow: "2px 2px 4px #0e2430",
                  fontSize: "2.5rem"
                }}
              />
            ),
            title: "Smarter Voyages",
            text: "Dynamic routing, real-time RPM, weather-driven ETA plans.",
          },
          {
            icon: (
              <FaShip
                style={{
                  color: "#0e2430", // Dodger Blue
                  textShadow: "2px 2px 4px #0e2430",
                  fontSize: "2.5rem"
                }}
              />
            ),
            title: "Stronger Ships",
            text: "Live performance data from your main engine to your cargo tanks.",
          },
          {
            icon: (
              <FaTools
                style={{
                  color: "#0e2430", // Green
                  textShadow: "2px 2px 4px #0e2430",
                  fontSize: "2.5rem"
                }}
              />
            ),
            title: "Cleaner Operations",
            text: (
              <>
                Automated emissions tracking, CII forecasting, and <br />
                FuelEU readiness.
              </>
            ),
          },
          {
            icon: (
              <FaRobot
                style={{
                  color: "#0e2430", // Purple
                  textShadow: "2px 2px 4px #0e2430",
                  fontSize: "2.5rem"
                }}
              />
            ),
            title: "Clear Decisions",
            text: "Role-based AI assistants that deliver the info you need—in seconds.",
          },
        ].map((card, i) => (
          <div className="main-feature-card" key={i}>
            <div className="card-icon">{card.icon}</div>
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </div>
        ))}
      </div>
    </section>


<section className="audience-section">
  <h2 className="audience-title">Built for the People Who Run Ships</h2>
  <p className="audience-sub">
    Not every visitor is an engineer. Not every decision comes from the bridge.
  </p>
  <p className="audience-sub2">
    That’s why AI Shipshape works for:
  </p>

 <div className="audience-cards">
  {[
    {
      title: "Masters & Chief Engineers",
      desc: "Who need clarity without complexity",
      icon: <FaUserTie style={{ color: "#77a77b" }} /> // Blue
    },
    {
      title: "Fleet Managers & Superintendents",
      desc: "Who need oversight and action",
      icon: <FaUsers style={{ color: "#77a77b" }} /> // Green
    },
    {
      title: "Owners & Charterers",
      desc: "Who need ROI, transparency, and control",
      icon: <FaCrown style={{ color: "#77a77b" }} /> // Gold
    },
    ].map((item, i) => (
      <div className="audience-card" key={i}>
        <div className="audience-icon">
          {item.icon}
        </div>
        <h3>{item.title}</h3>
        <p>{item.desc}</p>
      </div>
    ))}
  </div>

  <p className="audience-footer">
    No fluff. No "AI washing." Just tools that work—designed by people who've been there.
  </p>
</section>

    {/* SECTION 5: Innovation You Can Trust */}
    <section className="innovation-section">
    <h2 className="innovation-title">Innovation You Can Trust</h2>
    <p className="innovation-subtitle">
        We're a new company—but we're not new to the industry.
    </p>

    <div className="innovation-grid">
        {[
            {
                text: "Multiple Patents Pending — in fuel measurement, voyage optimisation, and real-time performance",
                icon: <FaCertificate />
            },
            {
                text: "Built Around Engineering, Seamanship & Trust",
                icon: <FaShieldAlt />
            },
            {
                text: "Retrofit-Friendly Systems — no need to cut pipes or dock ships",
                icon: <FaWrench />
            },
            {
                text: "Backed by Top Maritime Experts — Built with AI from Day One",
                icon: <FaGraduationCap />
            },
        ].map((item, index) => (
        <div className="innovation-item" key={index}>
            <div className="innovation-icon">
                {item.icon}
            </div>
            <div className="innovation-text innovation-line">
                {item.text}
            </div>
        </div>
        ))}
    </div>
    </section>
    {/* SECTION 6: One Platform. Every Insight */}
    <section className="platform-section">
    <h2 className="platform-title">One Platform. Every Insight.</h2>
    <p className="platform-subtitle">Shipshape IQ™ is the brain behind everything we do.</p>
    <p className="platform-desc">It powers your:</p>

    <div className="platform-cards-grid">
       {[
        {
          title: "Shipshape Captain™",
          subtitle: "Voyage & Fuel Planning",
          icon: (
            <FaCompass
              style={{
                color: "#0e2430",
                textShadow: "1px 1px 2px #0e2430",
                fontSize: "2.2rem"
              }}
            />
          ),
        },
        {
          title: "Shipshape Chief™",
          subtitle: "Vessel Monitoring & Alerts",
          icon: (
            <FaTachometerAlt
              style={{
                color: "#0e2430",
                textShadow: "1px 1px 2px #0e2430",
                fontSize: "2.2rem"
              }}
            />
          ),
        },
        {
          title: "Shipshape Carbon™",
          subtitle: "Emissions Compliance",
          icon: (
            <FaLeaf
              style={{
                color: "#0e2430",
                textShadow: "1px 1px 2px #0e2430",
                fontSize: "2.2rem"
              }}
            />
          ),
        },
        {
          title: "Shipshape Chat Suite™",
          subtitle: "Department AI Assistants",
          icon: (
            <FaComments
              style={{
                color: "#0e2430",
                textShadow: "1px 1px 2px #0e2430",
                fontSize: "2.2rem"
              }}
            />
          ),
        },
        ].map((item, index) => (
        <div className="platform-card" key={index}>
            <div className="platform-icon">
                {item.icon}
            </div>
            <div className="platform-card-content">
            <h3>{item.title}</h3>
            <p>{item.subtitle}</p>
            </div>
        </div>
        ))}
    </div>
    </section>


    <section className="scale-section">
        <h2 className="scale-title">Start With One Ship. Scale to the Fleet.</h2>
        <p className="scale-subtext">We know shipping. We know budgets.</p>
        <p className="scale-highlight">
            <strong>So we made Shipshape easy to start, modular to scale, and powerful from day one.</strong>
        </p>

        <div className="scale-box">
            <p className="scale-box-heading">
            From bridge to boardroom, you'll always have the answer:
            </p>
            <ul className="scale-questions">
            <li>"What's the next port for MV Orion?"</li>
            <li>"Show me the CII forecast for this quarter."</li>
            <li>"Alert me if purifier load exceeds 80%."</li>
            </ul>
        </div>
        </section>

        {/* <section className="coming-soon-section">
            <h2 className="coming-title">Coming Soon:<br />The Next Wave of Maritime Intelligence</h2>
            <p className="coming-sub">
                At AI Shipshape, innovation never docks.
            </p>
            <p className="coming-highlight">
                <strong>
                These soon-to-launch tools are designed to solve problems shipowners face every day—
                without disrupting your operations:
                </strong>
            </p>

            <div className="coming-cards">
                {[
                {
                    title: "Shipshape Engine Performance™",
                    desc: "Real-time combustion and cylinder diagnostics—no crankshaft mods required.",
                },
                {
                    title: "Shipshape ThrustPower™",
                    desc: "Lightweight torque, power, and thrust monitoring for true shaftline performance.",
                },
                {
                    title: "Shipshape Vision Mass Flow Reader™",
                    desc: "AI camera + thermal imaging that turns any analogue flowmeter into a compliant digital mass flow system. No retrofit needed.",
                },
                ].map((tool, index) => (
                <div className="coming-card" key={index}>
                    <span className="coming-tag">COMING SOON</span>
                    <h3>{tool.title}</h3>
                    <p>{tool.desc}</p>
                </div>
                ))}
            </div>

            <p className="coming-footer">
                <em>Be the first to try them—join our early access programme.</em>
            </p>

            <button className="join-btn" onClick={() => onNavigate('contact')}>JOIN</button>
            </section> */}



            <section className="lets-talk-section">
            <div className="lets-talk-content">
                <h2>Let’s Talk</h2>
                <p>This isn't just about digital transformation.</p>
                <p className="bold-line">
                It’s about doing what we’ve always done—running good ships—just with better tools.
                </p>
                <div className="talk-buttons">
                {/* <button className="trial-btn">Start Your FREE Trial</button> */}
                <button className="expert-btn" onClick={() => onNavigate('contact')}>Talk to Expert</button>
                </div>

                <p className="fleet-tagline">Bring clarity, control, and confidence to your fleet</p>

            </div>
            </section>

        <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default Main;
